import { render, staticRenderFns } from "./StationGeneralDetails.vue?vue&type=template&id=32fb8351&"
import script from "./StationGeneralDetails.vue?vue&type=script&lang=js&"
export * from "./StationGeneralDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports